const urlSrc = {
  sourceUrl:'https://app.gstscc.cn/',
  imageUrl: 'https://app.gstscc.cn/',
  webPlatFromUrl: 'https://app.gstscc.cn:19010/api/',
  appServerUrl:'https://app.gstscc.cn:19012/api/', //数据中心服务接口api
  dataServerUrl:'https://app.gstscc.cn:19011/api/',
  trafficServerUrl:'https://app.gstscc.cn:19013/', //路况系统服务
  color: {
    themeColor: "#19B05A",//导航主题色
    searchBg: "#ffffff",//search 背景色
    searchPlaceholder: "#D0D0D0" ,//search 提示文字颜色
    searchText:"#5E5E5E"
  },
  mapKey: "2e4a8fb4fb0a9aa19f5f8df10088ed64",
};
export default urlSrc;



// WEBPACK FOOTER //
// ./src/common/UrlSource.js